"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var SliderTrack = _styledComponents.default.div.withConfig({
  displayName: "SliderTrack",
  componentId: "sc-3h7v77-0"
})(["position:relative;height:100%;width:100%;display:inline-block;white-space:nowrap;overflow:hidden;vertical-align:top;"]);
var _default = SliderTrack;
exports.default = _default;